import React from "react";
import "../Style/Component/Riderdetails.css";
import call from "../Assets/Trackride/call.svg";
import star from "../Assets/Trackride/greystar.svg";
import yellowstar from "../Assets/Trackride/yellowstar.svg";

const Riderdetails = ({ ridedetails }) => {
  function formatDateWithRelativeTime(isoString) {
    const date = new Date(isoString);

    // Format date like "Feb 10, 6:00 PM"
    const formattedDate = date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return `${formattedDate}`;
  }
  function formatToINR(amount) {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(amount);
  }

  return (
    <div className="dealerdetails">
      <div className="dealerdetailsheader">
        {/* <img src={back} /> */}
        <h2>Driver Details</h2>
        <a
          onClick={() =>
            (window.location.href = `tel:${ridedetails?.dealerDetails?.phone}`)
          }
          className="call-btn"
        >
          <img src={call} alt="Call" />
        </a>
      </div>

      <div className="dealerdetailsbody">
        <table className="dealerdetailsbodytable">
          <thead>
            <tr>
              <th>Driver Name</th>
              <th>Vehicle Name</th>
              <th>Phone Number</th>
              <th>Pickup Time</th>
              <th>Drop Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{ridedetails?.driverDetails?.driverName}</td>
              <td>{ridedetails?.raw?.vehicleCategory}</td>
              <td>{ridedetails?.driverDetails?.phoneNumber}</td>
              <td>
                {ridedetails?.raw?.statusTimeline?.[3]?.timestamp
                  ? formatDateWithRelativeTime(
                      ridedetails?.raw?.statusTimeline?.[3]?.timestamp,
                    )
                  : "Not yet Picked"}
              </td>
              <td>
                {ridedetails?.raw?.statusTimeline?.[5]?.timestamp
                  ? formatDateWithRelativeTime(
                      ridedetails.raw.statusTimeline[5].timestamp,
                    )
                  : "Not yet Dropped"}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="bodybottom">
          <div className="bb1">
            <p className="md">Kilo Meter</p>
            <span className=".md">{ridedetails?.raw?.rideDistanceKm}</span>
          </div>

          <div className="bb1">
            <p className="md">Amount collected</p>
            <span className=".md">
              {ridedetails?.raw?.paymentStatus === "paid"
                ? formatToINR(ridedetails?.raw?.price)
                : 0}
            </span>
          </div>

          <p className="md">
            Review
            <span>
              {[...Array(5)].map((_, index) => (
                <img
                  key={index}
                  src={
                    index < (ridedetails?.driverDetails?.review || 0)
                      ? yellowstar
                      : star
                  }
                  alt="star"
                  className="star-icon"
                />
              ))}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Riderdetails;
